import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import type { Client } from '#types/client/client.type';

import { Uri } from '#constants/uri';

/**
 * Fetches a list of clients from the API.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param search - (Optional) A search string to filter the clients.
 * @returns A promise that resolves to an {@link OperationResultWithData} containing an array of {@link Client} objects.
 * @throws Throws an error if the request fails.
 */
export const getClients = async (instance: KyInstance, search?: string) => {
  try {
    return await instance
      .get<OperationResultWithData<Client[]>>(Uri.lookup.client, {
        searchParams: {
          search,
        },
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
